import {
  UPDATE_CART,
  UPDATE_CUSTOMER,
  ONLINE_CHECKOUT_SUCCESS,
  ONLINE_CHECKOUT_FAILED,
  RESTORE_CART,
  VERIFY_COUPON,
  CLEAR_COUPON,
  CLEAR_ERROR
} from '../actions/orderActions';

const initState = {
  cart: {
    origin: "ONLINE",
    customer: {},
    items: [],
    coupon: null,
    num_items: 0,
    subtotal: 0,
    retry_path: null
  },
  payment: null,
  error: null,
  couponError: null
}

const orderReducer = (state = initState, action) => {
  switch (action.type) {
    case UPDATE_CART:
      if (action.payload) {
        return {
          ...state,
          cart: {
            ...state.cart,
            items: [...action.payload.items],
            num_items: action.payload.num_items,
            subtotal: action.payload.subtotal,
            retry_path: action.payload.retry_path
          }
        };
      } else
        return state;

    case UPDATE_CUSTOMER:
      if (action.payload) {
        return {
          ...state,
          cart: {
            ...state.cart,
            customer: action.payload
          }
        };
      } else
        return state;

    case ONLINE_CHECKOUT_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          payment: action.payload,
          error: null
        };
      } else
        return state;

    case ONLINE_CHECKOUT_FAILED:
      if (action.payload) {
        return {
          ...state,
          payment: null,
          error: action.payload.error
        };
      } else
        return { ...initState };

    case RESTORE_CART:
      if (action.payload)
        return {
          cart: {
            ...action.payload
          }
        }
      else
        return state;

    case VERIFY_COUPON:
      return {
        ...state,
        cart: {
          ...state.cart,
          coupon: (typeof action.payload === 'object') ? action.payload : null
        },
        couponError: (typeof action.payload === 'string') ? action.payload : null
      };

    case CLEAR_COUPON:
      return {
        ...state,
        cart: {
          ...state.cart,
          coupon: null
        },
        couponError: null
      }

    case CLEAR_ERROR:
      return {
        ...state,
        error: null
      }

    default:
      return state;
  }
}

export default orderReducer;